import { FC } from 'react';
import { translate } from '../../i18n';
import { AddedCardIcon } from '../CardStatusModal/icons';
import { paymentSuccessPanelStyles as styles } from './styles';

export type PaymentSuccessStatus = 'approved' | 'pending';

export interface PaymentSuccessPanelProps {
  status: PaymentSuccessStatus;
  /** Número de pedido (se muestra formateado para el usuario). */
  orderId?: string;
  /** Checkout web: el host redirige a VTEX orderPlaced. */
  redirecting?: boolean;
  testID?: string;
}

export const PaymentSuccessPanel: FC<PaymentSuccessPanelProps> = ({
  status,
  orderId,
  redirecting = false,
  testID = 'payment-success-panel',
}) => {
  const titleKey =
    status === 'approved' ? 'paymentsUI.result.approved' : 'paymentsUI.result.pending';

  return (
    <div style={styles.panel} data-testid={testID} role="status" aria-live="polite">
      <div style={styles.iconWrapper}>
        <AddedCardIcon />
      </div>
      <h2 style={styles.title}>{translate(titleKey)}</h2>
      {status === 'approved' ? (
        <p style={styles.lead}>{translate('paymentsUI.result.approvedLead')}</p>
      ) : null}
      {orderId ? (
        <p style={styles.orderLine}>
          {translate('paymentsUI.result.orderNumber', { orderId: toOrderGroupIdDisplay(orderId) })}
        </p>
      ) : null}
      {redirecting ? (
        <p style={styles.redirecting}>{translate('paymentsUI.result.redirecting')}</p>
      ) : null}
    </div>
  );
};

/** Misma regla que VTEX `?og=` en orderPlaced. */
const toOrderGroupIdDisplay = (orderId: string): string => {
  const match = orderId.trim().match(/^(.+)-\d{2}$/);
  return match ? match[1] : orderId.trim();
};
